import useSearchParams from '@hooks/useSearchParams'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getData, postData } from '@pages/Event/simulate/v2/axios/axios'
import { API_URL } from '@apis/axios'

type RequestParamsType = {
  userId: string
}
export type ResponseSamsungEventDataType = {
  isTarget: boolean
  alreadyParticipate: boolean
  existsSamsungAccount: boolean
}

const stagingAPI = 'https://staging-api.metalogos.site'

const useSamsungInterestEvent = (
  mode: 'production' | 'staging' = 'production'
) => {
  const searchParams = useSearchParams()
  const userId = searchParams.getParam('userId')

  const postSamsungInterestEvent = useMutation({
    mutationFn: async (body: RequestParamsType) =>
      await postData<undefined, RequestParamsType>(
        API_URL.SAMSUNG_INTEREST_EVENT,
        body
      ),
  })

  const getSamsungInterestEvent = useQuery({
    queryKey: ['samsung-interest-event', userId],
    enabled: !!userId,
    queryFn: async () =>
      await getData<ResponseSamsungEventDataType, RequestParamsType>(
        API_URL.SAMSUNG_INTEREST_EVENT,
        { userId },
        {
          baseURL:
            mode === 'staging'
              ? stagingAPI
              : process.env.REACT_APP_REST_API_URI,
        }
      ),
    select: ({ data }) => data.data,
  })
  return { getSamsungInterestEvent, postSamsungInterestEvent }
}
export default useSamsungInterestEvent
